<script setup lang="ts">
import { Check as CheckIcon } from '@lucide/vue'

import type { Component } from 'vue'

/**
 * Standard menu row for BaseMenu: optional leading icon + label (default slot) + trailing check when
 * selected. Single-root <button> so data-*-menu / @click(.stop) fall through. `selected` paints the
 * emerald applied state and shows the checkmark; this standardises the check on the trailing edge
 * (some legacy menus had it leading).
 */
interface Props {
  selected?: boolean
  disabled?: boolean
  icon?: Component
}
const props = withDefaults(defineProps<Props>(), { selected: false, disabled: false })
</script>

<template>
  <button
    type="button"
    :disabled="props.disabled"
    class="flex w-full items-center gap-2 px-3 py-2 text-left text-xs transition-colors hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
    :class="
      props.selected
        ? 'bg-emerald-50 font-medium text-emerald-700'
        : 'text-gray-700 hover:bg-gray-50'
    "
  >
    <component :is="props.icon" v-if="props.icon" class="h-3.5 w-3.5 shrink-0" />
    <slot />
    <CheckIcon v-if="props.selected" class="ml-auto h-3 w-3 shrink-0 text-emerald-600" />
  </button>
</template>
